import { useContext } from 'react'
import { useRouter } from 'next/router'

import { SubscriptionContext } from '../components/context'
import { isError } from '../types/types'
import { NondescriptError } from '../components/NondescriptError'

function Arcade() {
  const { subscription, loading: subscriptionLoading } =
    useContext(SubscriptionContext)
  const router = useRouter()

  if (isError(subscription)) {
    return (
      <NondescriptError message="Failed to fetch information related to payments and subscriptions." />
    )
  }

  if ((!subscription || !subscription.arcadeLink) && !subscriptionLoading) {
    router.push('/subscription')
  }

  const isWindows = navigator.userAgent.indexOf('Win') !== -1
  const winUrl =
    'https://nautilus.reasonstudios.com/latest_companion_installer/win/'
  const macUrl =
    'https://nautilus.reasonstudios.com/latest_companion_installer/mac/'

  return (
    <>
      <div className="mb-20">
        <h3>Reason+ Arcade</h3>
        <div className="mb-20">
          You have now subscribed to the Arcade & Reason+ Bundle! To get
          started, follow the instructions below.
        </div>
        <div>
          <h5 className="mb-20">1. Install the Reason Companion</h5>
          <div className="d-flex flex-column align-items-center">
            <div>
              <a
                href={isWindows ? winUrl : macUrl}
                className="btn btn-light text-nowrap">
                <i className={`fa fa-${isWindows ? 'windows' : 'apple'}`}>
                  &nbsp;&nbsp;
                </i>
                Download for {isWindows ? 'windows' : 'mac'}
              </a>
            </div>
            <div>
              <a href={isWindows ? macUrl : winUrl} className="text-small">
                Download for {isWindows ? 'mac' : 'windows'}
              </a>
            </div>
          </div>
        </div>
        <div className="mb-20">
          <h5>2. Install Reason</h5>
          Once you have the Companion installed, you will be prompted to install
          Reason 12 which installs the Reason Rack Plugin (VST3/AU/AAX) and
          standalone DAW
        </div>
        <div className="mb-20">
          <h5>3. Redeem your Arcade subscription</h5>
          <div className="d-flex flex-column align-items-center">
            <a
              className="text-center"
              href={subscription?.arcadeLink}
              target="_blank"
              rel="noreferrer">
              <div className="btn btn-light text-nowrap">
                Redeem your arcade subscription
              </div>
              <div>
                <small>{subscription?.arcadeLink}</small>
              </div>
            </a>
          </div>
        </div>
        <div>
          If you want to read more about getting started with the bundle, read
          more here{' '}
          <a
            href="https://plugin.reasonstudios.com/arcadebundle"
            rel="noreferrer"
            target="_blank">
            https://plugin.reasonstudios.com/arcadebundle
          </a>
        </div>
        <hr />
        <h4>Need Help ?</h4>
        If you experience any problems activating or using Arcade please contact
        Output at <a href="https://support.output.com">support.output.com</a>
        Do not hesitate to contact Reason Studios at{' '}
        <a href="https://help.reasonstudios.com">help.reasonstudios.com</a> if
        you have any other concerns or questions related to Reason or your
        subscription.
      </div>
    </>
  )
}

export default Arcade
